import { isEmpty, isNull, isUndefined } from "__barrel_optimize__?names=isEmpty,isNull,isUndefined!=!lodash-es";
export const tryParseJson = str => {
  let result;
  if (typeof str !== "string") {
    return str;
  }
  try {
    result = JSON.parse(str);
    return result;
  } catch (error) {
    return false;
  }
};
export function hsbToRgb(h, s, v) {
  s = s / 100;
  v = v / 100;
  const h1 = Math.floor(h / 60) % 6;
  const f = h / 60 - h1;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  let r = 0,
    g = 0,
    b = 0;
  switch (h1) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
  }
  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
export const isInvalid = value => isUndefined(value) || isNull(value) || isEmpty(value);
export function isMobile(userAgent) {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
}
export const getTagName = tagName => {
  if (!tagName) return "";
  return tagName.split(" ").reduce((total, item) => {
    var _item__toLocaleUpperCase, _item_, _item_substring;
    total += "".concat(item === null || item === void 0 ? void 0 : (_item_ = item[0]) === null || _item_ === void 0 ? void 0 : (_item__toLocaleUpperCase = _item_.toLocaleUpperCase) === null || _item__toLocaleUpperCase === void 0 ? void 0 : _item__toLocaleUpperCase.call(_item_)).concat(item === null || item === void 0 ? void 0 : (_item_substring = item.substring) === null || _item_substring === void 0 ? void 0 : _item_substring.call(item, 1, item === null || item === void 0 ? void 0 : item.length));
    return total;
  }, "");
};
export const rennderWordBySpace = name => {
  if (!name) return "";
  const Regx = /[A-Z]/;
  let res = "",
    i = 0;
  while (i < name.length) {
    const item = name[i];
    if (Regx.test(item) && i > 0) {
      res += " ".concat(item);
    } else {
      res += item;
    }
    i++;
  }
  return res;
};
const faqDefaultData = {
  "What is a1.art?": "a1.art is an AI-powered art generator that creates digital artwork in various styles based on user input.",
  "Do I need any artistic skills to use a1.art?": "No, a1.art is designed for everyone! Whether you're an artist or a beginner, you can create stunning visuals easily.",
  "Can I use a1.art for commercial purposes?": "Yes! Artwork generated by a1.art can be used for personal and commercial projects, depending on the usage terms.",
  "What types of styles does a1.art support?": "a1.art offers a variety of styles, including realistic, anime, abstract, cyberpunk, and more.",
  "Is there a free version of a1.art?": "Yes, a1.art provides free access with limited features. For more advanced options, you can explore premium plans."
};
// 兜底处理 少于5条用默认数据补充
export const getFaq = data => {
  if (!data) {
    return faqDefaultData;
  }
  try {
    const _data = JSON.parse(data);
    if (Object.keys(_data).length < 5) {
      const _res = {
        ..._data,
        ...faqDefaultData
      };
      return Object.keys(_res).reduce((total, item, i) => {
        if (i < 5) {
          total[item] = _res[item];
        }
        return total;
      }, {});
    } else {
      return _data;
    }
  } catch (error) {
    return faqDefaultData;
  }
};
export const pasreTagNameForReq = tagName => {
  if (!tagName) return "";
  let _tagName = "";
  const match = tagName.match(/^ai-((?:[^-]+-)+)art-generator$/);
  if (match) {
    const middle = match[1].slice(0, -1); // 去掉最后一个 "-"
    const parts = middle.split("-");
    _tagName = parts.reduce((total, item, i) => {
      if (i !== parts.length - 1) {
        total += item + " ";
      } else {
        total += item;
      }
      return total;
    }, "");
  }
  return _tagName;
};
/**
 * 检测网络环境和地区信息的独立函数
 * @returns Promise<{ isInChina: boolean; canAccessInternet: boolean; isChinese: boolean }>
 */
export async function detectClientEnvironment() {
  const isChinese = ["zh-CN", "zh"].indexOf(navigator.language) !== -1;
  let canAccessInternet = false;
  let isInChina = true;
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort();
    }, 5000);
    await fetch("https://pbs.twimg.com/profile_images/1776953693142986752/cXVzc-0G_x96.jpg", {
      cache: "no-store",
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    // 如果能访问到外网资源，说明不在中国或者有VPN
    canAccessInternet = true;
    isInChina = isChinese;
  } catch (e) {
    console.log("网络访问受限，可能在中国境内");
    canAccessInternet = false;
    isInChina = true;
  }
  return {
    isInChina,
    canAccessInternet,
    isChinese
  };
}
// 触发用户打标nsfw埋点参数
export const suffix = "?scene=nsfw";
// nsfw 标签id
export const LABEL_ID = "nsfw";
export const extractBaseUrl = url => {
  const match = url.match(/^https?:\/\/([^?]+)/);
  return match ? match[1] : null;
};
// 生成webview目标url
export const getBaseUrl = () => {
  var _url_split;
  let url = extractBaseUrl(window.location.href);
  if (url && (url === null || url === void 0 ? void 0 : (_url_split = url.split) === null || _url_split === void 0 ? void 0 : _url_split.call(url, "/").length) > 1) {
    const arr = url.split("/");
    // 非详情页跳转到首页 nsfw下
    if (!([4, 5].includes(arr[arr.length - 1].length) && /^\/[a-z0-9]{4,6}/.test("/".concat(arr[arr.length - 1])))) {
      const _url = extractBaseUrl(window.location.origin);
      url = "".concat(_url).concat(suffix, "&labelId=").concat(LABEL_ID);
    }
  }
  return (url === null || url === void 0 ? void 0 : url.includes(suffix)) ? url : url + suffix;
};
// 生成下载吊起link链接
export const GenerateLink = source => {
  // 详情页
  return "intent://a1.art".concat(suffix, "&labelId=").concat(LABEL_ID, "#Intent;scheme=https;package=art.a1.twa;S.browser_fallback_url=https://play.google.com/store/apps/details?id=art.a1.twa&referrer=utm_source%3D").concat(source, ";end");
};
export const AppStoreUrl = "https://apps.apple.com/us/app/a1-art-fun-ai-photo-generator/id6748423076";
export const GenerateIOSLink = source => {
  const params = new URLSearchParams();
  params.set("utm_source", "h5");
  if (source) {
    params.set("plan", source);
  }
  return AppStoreUrl + "?" + params.toString();
};